<template>
  <b-card no-body>
    <b-card-body v-if="$slots.error" class="small text-center text-danger">
      <slot name="error"></slot>
    </b-card-body>
    <b-tabs card>
      <b-tab v-for="tab in tabs" :key="tab.index">
        <!---V-slot form --->
        <template #title>
          <slot name="header" v-bind:header="tab"></slot>
        </template>

        <slot name="form" v-bind:form="tab"></slot>

        <!---V-slot remove item --->
        <b-button size="sm" variant="danger" class="float-right my-3" @click="closeTab(tab)">
          Supprimer
        </b-button>
      </b-tab>

      <template #tabs-end>
        <b-nav-item role="presentation" id="btn-newtab" @click.prevent="newTab" href="#">
          <b><i class="fa fa-plus" aria-hidden="true"></i></b>
        </b-nav-item>
      </template>

      <!-- Render this if no tabs -->
      <template #empty>
        <div class="text-center text-muted">
          Il n'y a aucun élement.<br>
          Ajouter en un  en utilisant le boutton <b>+</b> au-dessus.
        </div>
      </template>
    </b-tabs>
  </b-card>
</template>

<script>
export default {
  name: 'CrudItem',
  props:{
    name: String,
    objToAdd: Object,
    value: Array,
    deletedId: Number
  },
  watch:{
    value(val){
      this.tabs = val
    },
    deletedId(val){
      if(val != null){
        this.tabs = []
      }
    }
  },
  data() {
    return {
      tabs: [],
      tabCounter: -1
    }
  },
  methods: {
    closeTab(x) {
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i] === x) {
          this.tabs.splice(i, 1)
        }
      }
    },
    newTab() {
      const obj = Object.assign({},this.objToAdd,{ index: this.tabs.length +1})
      this.tabs.push(obj)
      this.$emit('input', this.tabs)
    }
  }
}
</script>

<style scoped>
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: transparent;
  border-bottom: none;
}
</style>
